import DataModule from "@/components/DataModule";
import { Badge } from "@/components/ui/badge";

export default function Customers() {
  return (
    <DataModule
      title="Customers"
      subtitle="Manage your customer directory, ledger and contacts"
      endpoint="customers"
      pageTestId="customers-page"
      fields={[
        { key: "name", label: "Customer Name", required: true },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email" },
        { key: "whatsapp", label: "WhatsApp" },
        { key: "gst_number", label: "GST Number" },
        { key: "pan_number", label: "PAN" },
        { key: "billing_address", label: "Billing Address", type: "textarea", full: true },
        { key: "shipping_address", label: "Shipping Address", type: "textarea", full: true },
        { key: "opening_balance", label: "Opening Balance", type: "number", default: 0 },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
      columns={[
        { key: "name", label: "Name", render: (c) => <span className="font-medium">{c.name}</span> },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "gst_number", label: "GST", render: (c) => c.gst_number ? <Badge variant="secondary">{c.gst_number}</Badge> : "—" },
      ]}
    />
  );
}
